import Vue from 'vue';
import Router from 'vue-router';
import routes from './routers.js';
Vue.use(Router);

export default new Router({
    routes: routes
});


// WEBPACK FOOTER //
// ./src/router/index.js